import { useRouter } from 'next/router';
import { CHECKOUT_ROUTES } from '../constants';

/**
 * Custom hook to determine if the current route is the checkout confirmation page.
 * @returns {boolean} True if the current route is "/checkout/confirmation", false otherwise.
 */
export function useIsConfirmationPage(): boolean {
  const router = useRouter();
  return router.asPath === CHECKOUT_ROUTES.CONFIRMATION;
}
